{
  "name": "prior-auth-facade",
  "version": "2026.11.1",
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --host=0.0.0.0 --c=local",
    "start:local:epa": "ng serve --host=0.0.0.0 --c=local-epa",
    "build": "ng build --source-map",
    "build:dev": "ng build --configuration development",
    "build:uat2": "ng build --configuration uat2",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test-headless": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "ng lint",
    "audit": "node node_modules/better-npm-audit audit -p -l high"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "@simpatico.ai/js-crd-client": "^2.2.0",
    "@simpatico.ai/lib-pas-request": "^1.0.54",
    "@smile-cdr/fhirts": "^2.3.0",
    "angular-oauth2-oidc": "^22.0.2",
    "better-npm-audit": "^3.11.0",
    "bootstrap": "^5.3.8",
    "cors": "^2.8.6",
    "dayjs": "^1.11.23",
    "lodash": "^4.18.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/localize": "^22.2.1",
    "@eslint/js": "^9.39.5",
    "@types/jasmine": "~5.1.8",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/lodash": "^4.17.25",
    "@types/node": "^22.15.18",
    "@typescript-eslint/eslint-plugin": "^8.68.0",
    "@typescript-eslint/parser": "^8.68.0",
    "angular-eslint": "^22.1.0",
    "eslint": "^9.26.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.7.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.68.0"
  },
  "overrides": {
    "csv-parse": "^7.0.3"
  }
}
